<template>
<!-- Footer -->
    <footer>
        <div class="footer-content">
            <div class="footer-info">
                <h3>Contact</h3>
                <p><strong>Email:</strong> <a href="mailto:vipandeeps595@gmail.com" aria-label="Email">vipandeeps595@gmail.com</a></p>
                <p><strong>Location:</strong> Mohali, Punjab, India</p>
            </div>
            
            <div class="footer-ventures">
                <h3>Ventures</h3>
                <p><a href="https://clientspreferred.com" target="_blank">ClientsPreferredProperties</a></p>
                <p><a href="https://bizzento.com" target="_blank">Bizzento</a></p>
                <p><strong>Status:</strong> Building & Scaling</p>
            </div>
        </div>
        
        <div class="footer-bottom">
            <p>© 2025 Vipandeep Singh. All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>

</style>
